<script>
    import { createEventDispatcher } from "svelte";
    
    const dispatch = createEventDispatcher();

    // See: https://www.w3schools.com/css/css_dropdowns.asp

    function toggleMenu() {
        const dd = document.querySelector('.dropdown-content');
        if (dd.style.display == 'block') {
            dd.style.display = 'none';
        } else {
            dd.style.display = 'block';
        }
    }

    function showViewPreferences()
    {
        const dd = document.querySelector('.dropdown-content');
        dd.style.display = 'none';
        dispatch("view")
    }

    function showSupportPanel()
    {
        const dd = document.querySelector('.dropdown-content');
        dd.style.display = 'none';
        dispatch("support")
    }

    function showALFXAnalysis()
    {
        const dd = document.querySelector('.dropdown-content');
        dd.style.display = 'none';
        dispatch("analysis")
    }

    function performSignOut()
    {
        const dd = document.querySelector('.dropdown-content');
        dd.style.display = 'none';
        dispatch("sign-out")
    }

</script>

<div class="dropdown">
    <button class="hamburger-button" aria-label="Menu" on:click={toggleMenu}>
        <span></span>
        <span></span>
    </button>
    <div class="dropdown-content">
        <a href={"#"} on:click={showViewPreferences}>View</a>
        <a href={"#"} on:click={showSupportPanel}>Support</a>
        <a href={"#"} on:click={showALFXAnalysis}>Analysis</a>
        <a id="sign-out" href={"#"} on:click={performSignOut}>Sign Out</a>
    </div>
</div>

<style>
    /* Style The Dropdown Button */
    .hamburger-button {
        display: inline-flex;
        flex-direction: column;
        justify-content: space-between;
        width: 32px;
        height: 24px;
        background-color: rgba(0, 0, 0, 0);
        border: none;
        cursor: pointer;
        margin: 15px auto auto 10px;
    }
    .hamburger-button span {
        display: block;
        width: 100%;
        height: 2px;
        background-color: white;
        border-radius: 2px;
    }
    /* The container <div> - needed to position the dropdown content */
    .dropdown {
        position: relative;
        display: inline-block;
    }
    .dropdown button {
        list-style-type: none;
        position: relative;
    }
    /* Dropdown Content (Hidden by Default) */
    .dropdown-content {
        display: none;
        position: absolute;
        top: 50px;
        right: -6px;
        font-size: 15px;
        background-color: white;
        min-width: 180px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        z-index: 1000;
    }

    /* Links inside the dropdown */
    .dropdown-content a {
        background-color: rgba(0, 0, 0, 0.6);
        color: white;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
    }

    /* Change color of dropdown links on hover */
    .dropdown-content a:hover {
        background-color: rgba(0, 0, 0, 0.5);
    }
    #sign-out {
        border-top: 0.5px solid #ddd;
    }
</style>
